// extracted by mini-css-extract-plugin
export var sliderRange = "_pa-2";
export var sliderRoot = "_pa-0";
export var sliderThumb = "_pa-3";
export var sliderTrack = "_pa-1";